// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-empty-state{display:flex;flex-direction:column;align-items:center;font-weight:400;font-size:18px;margin-top:32px;min-height:12rem}.light-theme .notification-empty-state{color:#333}.dark-theme .notification-empty-state{color:#c8c3bc}.notification-empty-state svg{width:80px;height:80px}.notification-empty-state .empty-state-message{margin-top:16px}", ""]);
// Exports
module.exports = exports;
